import CryptoJS from 'crypto-js';
import LocalStorageManager from 'managers/LocalStorageManger';
import storage from 'redux-persist/lib/storage';
import { login } from 'routes/AppUrls';
import { persistor } from 'store';

export const availableLocales = ['en', 'ar'];

const secretKey =
  'Empowering Small and Medium Enterprises with customized financing solutions';

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

export const decryptData = (data) => {
  const bytes = CryptoJS.AES.decrypt(data, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export function isAuthenticated() {
  return LocalStorageManager.getItem('token');
}

export function getUserRole() {
  return LocalStorageManager.getItem('Role');
}

export const getDefaultLanguage = (local) => {
  return local;
};

export function injectString(str, index, stringToAdd) {
  return (
    str.substring(0, index) + stringToAdd + str.substring(index, str.length)
  );
}

export function PhoneNumberVerification(value) {
  const regex = /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
  return regex.test(value);
}
export function OnlyAlphabet(value) {
  const regex = /^[A-Za-z]+$/;
  return regex.test(value);
}

export function Emailverification(value) {
  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return regex.test(value);
}

export function PasswordValidation(value) {
  const regex =
    /^(?=.*[0-9])(?=.*[!@#$%^&*£])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*£]{8,16}$/;
  return regex.test(value);
}

export function PriceFomate(value) {
  if (isNaN(value)) {
    return '';
  }
  return Number(value)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function isJSONString(str) {
  const jsonPattern = /^\s*(\{.*\}|\[.*\])\s*$/;
  return jsonPattern.test(str);
}

export function checkAuthorization() {
  const storedToken = LocalStorageManager.getItem('token');

  if (storedToken) {
    const token = storedToken;

    const createdDate = new Date(token.created);
    const created = Math.round(createdDate.getTime() / 1000);
    const ttl = 1209600;
    const expiry = created + ttl;

    if (created > expiry) return false;

    return true;
  }

  return false;
}

export function IsJSONString(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export function ClearTokenRedirectLogin(navigate) {
  LocalStorageManager.removeItem('token');
  LocalStorageManager.removeItem('Role');
  LocalStorageManager.removeItem('registerToken');
  storage.removeItem('persist:persist-store');
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
  navigate(login('en'));
  window.location.reload();
}

export function screenScrollTop() {
  window.scrollTo({
    top: 500,
    behavior: 'smooth',
  });
}

export function checkClientAuthorization({ dispatch, getState }) {
  return (nextState, replace, next) => {
    const client = getState().client;

    if (client && client.token) return next();

    if (checkAuthorization(dispatch)) return next();

    replace('signin');
    return next();
  };
}

export const getDeviceName = () => {
  const userAgent = navigator.userAgent;

  let deviceName = '';

  if (userAgent.match(/Android/)) {
    deviceName = 'Android';
  } else if (userAgent.match(/iPhone/)) {
    deviceName = 'iPhone';
  } else if (userAgent.match(/iPad/)) {
    deviceName = 'iPad';
  } else if (userAgent.match(/Macintosh/)) {
    deviceName = 'Mac';
  } else {
    deviceName = 'Web';
  }

  return deviceName;
};

export const getDeviceVersion = () => {
  let deviceVersion = '';

  const userAgent = navigator.userAgent;
  const regex = /\(.*?([0-9]+(?:(?:\.|-)[0-9]+)*)/;
  const match = userAgent.match(regex);

  if (match && match.length > 1) {
    deviceVersion = match[1];
  }

  return deviceVersion;
};

export const getOSType = () => {
  const osType = navigator.platform;

  return osType;
};

export const getDeviceId = () => {
  let deviceId = '';

  if (navigator.hardwareConcurrency) {
    deviceId = navigator.hardwareConcurrency.toString();
  } else {
    deviceId = navigator.productSub;
  }

  return deviceId;
};

export const getTimeZone = () => {
  let timeZone = '';
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timeZone;
};

export const getDeviceIMEI = () => {
  const userAgent = navigator.userAgent;

  return userAgent;
};
